<template>
    <div class="na-form">
        <div v-if="termDetail" class="left" :version="version">
            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">Id:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='termDetail.TerId' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.Competition}}:</div>
                    <div class="dx-field-value">
                        <DxSelectBox displayExpr="RouName" :showClearButton="true" :dataSource="roundList" valueExpr="RouId" v-model:value="termDetail.RouId">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.Type}}:</div>
                    <div class="dx-field-value">
                        <DxSelectBox displayExpr="TetName" :dataSource="termTypeList" valueExpr="TetId" v-model:value="termDetail.TetId">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.ValidFrom}}:</div>
                    <div class="dx-field-value">
                        <DxDateBox v-model:value='termDetail.TerValidBegin' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.Name}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='termDetail.TerName' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.TerRedirectUrl}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='termDetail.TerRedirectUrl' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.Activ}}:</div>
                    <div class="dx-field-value">
                        <DxCheckBox v-model:value='termDetail.TerValid' />
                    </div>
                </div>
                <div class="dx-field ">
                    <div class="dx-field-label html-label">{{captions.Document}}:</div>
                    <DxHtmlEditor class="html-dx-field" v-model:value="termDetail.TerHtml"
                                  value-type="html">
                        <DxToolbar>
                            <DxItem name="undo" />
                            <DxItem name="redo" />
                            <DxItem name="separator" />
                            <DxItem :accepted-values="sizeValues"
                                    name="size" />
                            <DxItem :accepted-values="fontValues"
                                    name="font" />
                            <DxItem name="separator" />
                            <DxItem name="bold" />
                            <DxItem name="italic" />
                            <DxItem name="strike" />
                            <DxItem name="alignRightunderline" />
                            <DxItem name="separator" />
                            <DxItem name="alignLeft" />
                            <DxItem name="alignCenter" />
                            <DxItem name="" />
                            <DxItem name="alignJustify" />
                            <DxItem name="separator" />
                            <DxItem name="color" />
                            <DxItem name="background" />
                            <DxItem name="link" />
                            <DxItem name="image" />
                            <DxItem name="separator" />
                            <DxItem name="clear" />
                            <DxItem name="codeBlock" />
                            <DxItem name="blockquote" />
                            <DxItem name="separator" />
                            <DxItem name="insertTable" />
                            <DxItem name="deleteTable" />
                            <DxItem name="insertRowAbove" />
                            <DxItem name="insertRowBelow" />
                            <DxItem name="deleteRow" />
                            <DxItem name="insertColumnLeft" />
                            <DxItem name="insertColumnRight" />
                            <DxItem name="deleteColumn" />
                        </DxToolbar>
                    </DxHtmlEditor>
                </div>


                <div class="dx-field">
                    <div class="dx-field-label">PDF:</div>
                    <div class="tdUpload">
                        <div>
                            <DxFileUploader  
                                            :multiple="false" 
                                            upload-mode="instantly"
                                            @value-changed="(s,e) => uploadDoc(s,e,1)" />
                        </div>
                        <div><a :href="termDetail.DocumentUrl" target="_blank">{{termDetail.DocumentName}}</a></div>
                    </div>
                </div>

                 
                <div class="dx-field">
                    <div class="dx-field-label html-label">
                        Alt-Document Html:
                    </div>
                    <DxHtmlEditor v-model:value="termDetail.TerHtml2"
                                  value-type="html"
                                  :height="200" class="html-dx-field">
                        <DxToolbar>
                            <DxItem name="undo" />
                            <DxItem name="redo" />
                            <DxItem name="separator" />
                            <DxItem :accepted-values="sizeValues"
                                    name="size" />
                            <DxItem :accepted-values="fontValues"
                                    name="font" />
                            <DxItem name="separator" />
                            <DxItem name="bold" />
                            <DxItem name="italic" />
                            <DxItem name="strike" />
                            <DxItem name="underline" />
                            <DxItem name="separator" />
                            <DxItem name="alignLeft" />
                            <DxItem name="alignCenter" />
                            <DxItem name="alignRight" />
                            <DxItem name="alignJustify" />
                            <DxItem name="separator" />
                            <DxItem name="color" />
                            <DxItem name="background" />
                            <DxItem name="link" />
                            <DxItem name="image" />
                            <DxItem name="separator" />
                            <DxItem name="clear" />
                            <DxItem name="codeBlock" />
                            <DxItem name="blockquote" />
                            <DxItem name="separator" />
                            <DxItem name="insertTable" />
                            <DxItem name="deleteTable" />
                            <DxItem name="insertRowAbove" />
                            <DxItem name="insertRowBelow" />
                            <DxItem name="deleteRow" />
                            <DxItem name="insertColumnLeft" />
                            <DxItem name="insertColumnRight" />
                            <DxItem name="deleteColumn" />
                        </DxToolbar>
                    </DxHtmlEditor>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">PDF:</div>
                    <div class="tdUpload">
                        <div>
                            <DxFileUploader  
                                            :multiple="false"
                                            upload-mode="instantly"
                                            @value-changed="(s,e) => uploadDoc(s,e,2)" />
                        </div>
                        <div><a :href="termDetail.DocumentUrlAlt" target="_blank">{{termDetail.DocumentAltName}}</a></div>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.ChangedOn}}:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='termDetail.TerChangedOn' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.ChangedBy}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='termDetail.TerChangedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.CreatedOn}}:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='termDetail.TerCreatedOn' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{captions.CreatedBy}}:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='termDetail.TerCreatedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="na-buttons-row">

                    <div>
                        <DxButton :width="120"
                                  :text="btn.SaveBtn"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton :width="120"
                                  :text="btn.DeleteBtn"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onDeleteClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton :width="120"
                                  :text="btn.CancelBtn"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script> 

    import axios from "axios";
    import { confirm, alert } from "devextreme/ui/dialog";
    import notify from 'devextreme/ui/notify';
    import { DxTextBox/*, DxTextArea*/ } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button'; 
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import { DxFileUploader } from 'devextreme-vue/file-uploader';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import $ from 'jquery';
    import {
        DxHtmlEditor,
        DxToolbar,
        DxItem
    } from 'devextreme-vue/html-editor';
    import '../assets/detailForm.less';
    const baseUri = "WebApi.asmx/api/TermService";

    export default {
        name: 'TermDetail',
        components: {
            DxFileUploader,
            DxButton,
            DxTextBox
            /*       DxTextArea*/,
            DxDateBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            DxCheckBox,
            DxSelectBox

        },
        data() {
            return {
                captions: {
                    Competition: this.$LanguageProvider.GetResource("Competition", "Caption", "Competition"),
                    Type: this.$LanguageProvider.GetResource("Type", "Caption", "Typ"),
                    ValidFrom: this.$LanguageProvider.GetResource("ValidFrom", "Caption", "Valid From"),
                    TerRedirectUrl: this.$LanguageProvider.GetResource("TerRedirectUrl", "Caption", "Redirect to URL"),
                    Name: this.$LanguageProvider.GetResource("Name", "Caption", "Name"),
                    Activ: this.$LanguageProvider.GetResource("Activ", "Caption", "Activ"), 
                    Document: this.$LanguageProvider.GetResource("Document", "Caption", "Document"),
                    CreatedOn: this.$LanguageProvider.GetResource("CreatedOn", "Caption", "Created On"),
                    CreatedBy: this.$LanguageProvider.GetResource("CreatedBy", "Caption", "Created By"),
                    ChangedBy: this.$LanguageProvider.GetResource("ChangedBy", "Caption", "Changed On"),
                    ChangedOn: this.$LanguageProvider.GetResource("ChangedOn", "Caption", "Changed By"),
                },
                btn: {
                    SaveBtn: this.$LanguageProvider.GetResource("SaveBtn", "Caption", "Update"),
                    DeleteBtn: this.$LanguageProvider.GetResource("DeleteBtn", "Caption", "Delete"),
                    CancelBtn: this.$LanguageProvider.GetResource("CancelBtn", "Caption", "Cancel"),
                },
                doc: {
                    data: [],
                    fileName: "",
                    mimeType: "",
                    version: 0
                }
            };
        },
        props: {
            terId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        created: function () {
        },
        computed: {
            termDetail() {
                return this.$store.state.termStore.termDetail
            },
            roundList() {
                return this.$store.state.roundStore.roundList
            },
            termTypeList() {
                return this.$store.state.termTypeStore.termTypeList
            },
        },
        mounted: function () {
            this.$store.dispatch("getRoundList", {})
            this.$store.dispatch("getTermTypeList", {})
            this.$store.dispatch("getTermDetail", { terId: this.terId })
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) { 
                        var formData = new FormData()
                        formData.append("TerId", this.terId)
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });
            },
            onSaveClick() {
                this.$store.dispatch("saveTermDateil")
            }, 
            uploadDoc(e, f, nr) {
                let reader = new FileReader()
                if (e.value && e.value.length > 0) {
                    reader.readAsDataURL(e.value[0])
                    reader.onload = function () {
                        switch (nr) {
                            case 1:
                                this.self.termDetail.Document = this.reader.result
                                this.self.termDetail.DocumentName = e.value[0].name
                                this.self.termDetail.DocumentMimeType = e.value[0].type
                                this.self.termDetail.HasDocument = true
                                break;
                            case 2:
                                this.self.termDetail.DocumentAlt = this.reader.result
                                this.self.termDetail.DocumentNameAlt = e.value[0].name
                                this.self.termDetail.DocumentMimeTypeAlt = e.value[0].type
                                this.self.termDetail.HasDocumentAlt = true
                                break;
                        }
                        this.component.reset()
                        this.self.version++
                    }.bind({ reader, self: this, component: e.component });

                }
            }, 
        }
    }


</script>
<style scoped>
    .tdUpload {
        width: 60%;
        display: flex;
    }
</style>
